import React from 'react';
import './EventoSelecionados.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Typography, Grid, Container, Button } from '@mui/material';

const EVENT_IMAGE = encodeURI('/media/eventos/A devoção popular na Idade Média.jpg');

export default function Adevolucao() {
    return (
        <div>
            <div class="TituloEventosSelecionados">
                <div class="row">
                    <Typography
                                                          variant="h4"
                                                          align="center"
                                                          gutterBottom
                                                          style={{
                                                            fontFamily: "'Lato', serif",
                                                            color: "white",
                                                            borderBottom: "4px solid #d4af37",
                                                            paddingBottom: "10px",
                                                            textTransform: "uppercase",
                                                            animation: "glow 2s infinite alternate",
                                                            marginTop: "7%"  // Aqui é onde você define o espaço superior
                                                          }}
                                                        > 
                         
                        <h1>A devoção popular na Idade Média</h1>
                        <h2>O ensino da fé cristã na Península Ibérica.</h2>
                    </Typography>
                </div>
            </div>

            <div className='EventosMov'>
                <div class="container" id='TituloEventosSelecionados'>
                   
                    <div class="row">
                        <div>
                            <div className="titulo-evento">
                                <h1>Palestra do Prof. Dr. Jean-Claude Schmitt na UNESP/Câmpus de Franca.

</h1>
                                <div class="border"></div>
                            </div>
                        </div>

                        <div className="evento-banner-row">
                            <img className="evento-banner-image" src={EVENT_IMAGE} alt="A devoção popular na Idade Média" />
                        </div>
 

                    </div>

                </div>
            </div>
          
        </div>
    )

}
